<template>
  <div class="box">
    <!--搜索区-->
    
    <!--内容区域-->
    <div class="content-box">
      <!--显示内容-->
      <hr />
      <!--列表区-->
      <el-table
        :data="datalist"
        :row-key="getRowKey"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        border
        stripe
      >
        <el-table-column
          type="index"
          :index="(queryInfo.page-1)*(queryInfo.page_size)+1"
          :resizable="false"
          label="#"
        ></el-table-column>
        <el-table-column label="Accession" prop="accession">
          <template slot-scope="scope">
            <a
              :href="['@/../#/content/?accession='+scope.row.accession]"
              style="text-decoration:none;"
            >{{scope.row.accession}}</a>
          </template>
        </el-table-column>
        <el-table-column label="Protein" prop="protein"></el-table-column>
          <el-table-column label="Gene(s)" prop="gene"></el-table-column>
          <el-table-column label="Organism" prop="organism">
             <template slot-scope="scope">
            <a
            :href="[ 'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=' + scope.row.tax_id,]"
              style="text-decoration:none;"
            >{{scope.row.organism}}</a>
          </template>
          </el-table-column>
          <el-table-column label="Common Name" prop="commonname"></el-table-column>
        <el-table-column label="Cofactor(s)" prop="symbol">
           <template slot-scope="scope">
            <el-button v-for="item in val(scope.row.symbol)" :key="item.id" type="primary" plain>{{item}}</el-button>
          </template></el-table-column> 
        <el-table-column label="Site" prop="site"></el-table-column>
        <el-table-column label="3D View" prop="accession">
          <template slot-scope="scope">
            <a :href="['//183.175.59.23:83#/swiper?accession='+scope.row.accession]" target="_blank" style="text-decoration:none;">
            <el-button type="primary" icon="el-icon-thumb" plain>Click</el-button></a>
          </template>
        </el-table-column>
      </el-table>
      <hr/>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //获取查询列表参数对象
      queryInfo: {
        metal:'',
        page_size: 10,
        page: 1,
      },
       activeName: '1',
       multipleSelection: [],
      dialogVisible: false,
      total: null,
      datalist: [],
      OptionsData: [],
      multipleSelection: [],
      url: "//183.175.59.23:8000/down?type=csv&params=",
      flag: false,
       loading: false,
       list:[],
       orglist:[],
       item:'',
    };
  },
  //获取查询列表
  created() {
    this.getTerms();
    this.onSubmit();
  },

  //方法
  methods: {
    //获取查询参数
     async getTerms() {
      if (this.$route.query["id"]) {
        this.queryInfo.metal = this.$route.query["id"];
      }
    },
    //
    async onSubmit() {
      const res = await this.$http.get("metals", { params: this.queryInfo});
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.datalist = res.data.results;
      this.total = res.data.count;
    },
    //分页索引
    //处理后端字符串
     val(str){
    var res = eval(str);
     return res;
   },


    //监听每页显示变化
    handleSizeChange(newPage_size) {
      this.queryInfo.page_size = newPage_size;
      this.onSubmit();
    },
    //
   
    //监听当前页变化
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage;
      this.onSubmit();
    },
    getRowKey(row) {
      return row.id;
    },
    handleSelectionChange(val) {
      var newList = [];
      val.forEach((obj) => {
        newList.push(obj.accession);
      });
      this.multipleSelection = newList;
    },
  },
};
</script>

<style lang="less" scoped>

.el-form-item{
  width:20%;
  margin:0;
 /deep/ .el-form-item__label{
    width: 40%;
  }
  /deep/.el-form-item__content{
    width:60%;
  }
}


.content-box{
  margin-top: 70px;
}
  

.el-pagination {
  display: flex;
  justify-content: center;
}
.el-form {
  /deep/ .el-form-item__label {
    color: rgb(8, 0, 0);
    font-size: 1.2em;
  }
}
.el-table {
  /deep/ th {
    background-color: #adc3ce;
    color: rgb(8, 0, 0);
    font-size: 1.3em;
    text-align: center;
  }
  /deep/ td {
    text-align: center;
  }
}
/deep/.el-dialog{
  width:420px;
  vertical-align: middle;
}
/deep/.el-dialog__header{
  text-align: left;
  padding: 0;
}
/deep/.el-dialog__body{
  text-align: left;
  padding: 5px 10px;

}
</style>